import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Salary, SalaryCalculateDTO } from '../employees/salary/model/salary.model';
import { SchoolService } from './school.service';
import { logRequest } from 'app/main/shared/http-utils';

@Injectable({
    providedIn: 'root',
})
export class SalaryService implements OnDestroy {
    baseUrl = '/school-service/api/salary';

    constructor(
        private http: HttpClient,
        private schoolService: SchoolService
    ) {
        console.log('School dto service created!');
    }

    calculate(dto: SalaryCalculateDTO, id?): Observable<HttpResponse<Salary[]>> {
        dto.schoolId = id ? id : this.schoolService.getActiveSchool().id;
        return this.http.post<Salary[]>(this.baseUrl, dto, { observe: 'response', headers: logRequest() });
    }

    search(dto: SalaryCalculateDTO, id?): Observable<HttpResponse<Salary[]>> {
        dto.schoolId = id ? id : this.schoolService.getActiveSchool().id;
        return this.http.post<Salary[]>(`${this.baseUrl}/search`, dto, { observe: 'response' });
    }

    approve(list: string[]): Observable<HttpResponse<Salary[]>> {
        return this.http.post<Salary[]>(`${this.baseUrl}/approve`, list, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    unapprove(list: string[]): Observable<HttpResponse<Salary[]>> {
        return this.http.post<Salary[]>(`${this.baseUrl}/unapprove`, list, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    delete(list: string[]): Observable<HttpResponse<any>> {
        return this.http.post<any>(`${this.baseUrl}/delete`, list, { observe: 'response', headers: logRequest() });
    }

    ngOnDestroy() {
        console.log('School dto service destroyed!');
    }
}
